/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friendprofileblockconfirm3Inputs */



/**
* | output |
* | --- |
* | "Block" |
*
* @param {Friendprofileblockconfirm3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const friendprofileblockconfirm3 = /** @type {((inputs?: Friendprofileblockconfirm3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friendprofileblockconfirm3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Block")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloquear")
	return /** @type {LocalizedString} */ ("Заблокировать")
});
export { friendprofileblockconfirm3 as "friendProfileBlockConfirm" }